module.exports = __webpack_public_path__ + "static/media/hd-logo.137dc5e0.png";